export default "__VITE_ASSET__f08e949a__"